import React from "react";
import { Nav } from "../../Components/index";
import {
  Header,
  Services,
  Aboutus,
  Teams,
  Features,
  Footer,
} from "../../Containers/index";

function Home() {
  return (
    <>
      <Nav />
      <Header />
      <Services />
      <Aboutus />
      <Teams />
      <Features />
      <Footer />
    </>
  );
}

export default Home;
